var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "text-multi-lines-wrapper",
      class: {
        "text-multi-lines-wrapper--show-all": _vm.showall,
      },
    },
    [
      _c(
        "div",
        { staticClass: "text-multi-lines-wrapper__inner" },
        [_vm._t("default")],
        2
      ),
      _vm.overflow
        ? _c("div", { staticClass: "text-multi-lines-wrapper__ellipsis" }, [
            _c(
              "span",
              {
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    return _vm.showAll()
                  },
                },
              },
              [
                _c(
                  "span",
                  { staticClass: "text-multi-lines-wrapper__ellipsis__text" },
                  [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.showall
                            ? _vm.$t("PtCustomFieldLabelPane.multiLines.less")
                            : _vm.$t("PtCustomFieldLabelPane.multiLines.more")
                        ) +
                        " "
                    ),
                  ]
                ),
                _c("PtIcon", {
                  class: { "query-less-icon": _vm.showall },
                  attrs: { icon: "SolidDoubleArrowDown" },
                }),
              ],
              1
            ),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }